import * as tslib_1 from "tslib";
import createUserConfigurationOperation from 'owa-service/lib/operation/createUserConfigurationOperation';
import createUserConfigurationRequest from 'owa-service/lib/factory/createUserConfigurationRequest';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getMailboxExportUserConfigurationName from './getMailboxExportUserConfigurationName';
export default function createMailboxExportRequest() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createUserConfigurationOperation({
                        Header: getJsonRequestHeader(),
                        Body: createUserConfigurationRequest({
                            UserConfiguration: serviceUserConfiguration({
                                UserConfigurationName: getMailboxExportUserConfigurationName(),
                            }),
                        }),
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.Body.ResponseMessages.Items[0]];
            }
        });
    });
}
//# sourceMappingURL=createMailboxExportRequest.js.map